import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  subContainer: {justifyContent: 'flex-start'},
  textAlign: {textAlign: 'left'},
  titleStyle: {marginLeft: 5},
});
